import React, { useState, useEffect } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Link,
  useHistory,
  Switch,
} from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import COLORS from "../resources/colors/COLORS";
import myToast from "../Utils/MyToast";
import AdmissionQueryDetails from "./AdmissionQueryDetails";

const AdmissionQuery = () => {
  const [loggedIn, setLoggedIn] = useState(true);
  const [loading, setLoading] = useState(false);
  const [mAdmissionQuery, setMAdmissionQuery] = useState([]);
  const history = useHistory();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setLoggedIn(false);
    }
    window.scrollTo(0, 0);
    getAdmissionQuery();
  }, []);

  const getAdmissionQuery = () => {
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const mSession = SessionManager.getCurrentSession();
    const SESSION_ID = mSession[0].session_id;
    const FUNCTION_NAME = "getAllAdmissionQuery.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;
    const params = {
      school_code: SCHOOL_CODE,
      session_id: SESSION_ID,
    };

    const queryString = new URLSearchParams(params).toString();
    //console.log("Full URL: ", `${URL}${queryString}`);

    axios
      .get(URL, {
        params: params,
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          setMAdmissionQuery(response.data);
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("error>>>>>", error);
      });
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  if (loading) {
    return <MyLoader />;
  }

  return (
    <Router>
      <Switch>
        <Route path="/AdminMain/AdmissionQuery" exact>
          <div className="content" style={{ background: COLORS.whitesmoke }}>
            <div className="content-header">
              <div className="leftside-content-header">
                <ul className="breadcrumbs">
                  <li>
                    <i className="fa fa-home" aria-hidden="true" />
                    <a href="#">Admission query</a>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className="bg_page_white_rounded box_shadow"
              style={{ "--mMargin": "100px" }}
            >
              <div
                className="row bg_card_primary"
                style={{ padding: "0px 20px 0px 20px" }}
              >
                <h4 className="gravity_center">
                  {"Admission Query(" + mAdmissionQuery.length + ")"}
                </h4>
              </div>

              <div className="row">
                {mAdmissionQuery.map((item, index) => (
                  <div className="col-sm-6 col-md-6" key={index}>
                    <Link
                      to={{
                        pathname:
                          "/AdminMain/AdmissionQueryDetails/" + item.request_id,
                      }}
                    >
                      <div
                        className="box_shadow bg_card_grey_outline"
                        style={{ padding: 2, margin: 10 }}
                      >
                        <h4 className="gravity_center">
                          {item.student_name + " (" + item.father_name + ")"}
                        </h4>
                        <h5 className="gravity_center">
                          {"Address: " + item.address}
                        </h5>
                        <h5 className="gravity_center">
                          {"Seeking Admission in Class: " + item.query_class}
                        </h5>
                        <h5 className="gravity_center">
                          {"Previous Class: " + item.previous_class}
                        </h5>
                        <h5 className="gravity_center">
                          {"Previous School: " + item.previous_school_name}
                        </h5>
                        <div className="row">
                          <div className="col-sm-12 col-md-12 gravity_center">
                            <button
                              className="btn btn-success"
                              style={{
                                fontSize: "16px",
                                margin: "3px 2px 3px 2px",
                                width: "100%",
                                background: COLORS.primary_color_shade5,
                              }}
                            >
                              View Details
                            </button>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Route>

        <Route
          path="/AdminMain/AdmissionQueryDetails/:request_id"
          component={AdmissionQueryDetails}
        />
      </Switch>
    </Router>
  );
};

export default AdmissionQuery;
